import ZohoDeskLogo from '../assets/tools-logos/tools-zoho-desk.svg';
import DeskProLogo from '../assets/tools-logos/tools-desk-pro.png';
import HubSpotLogo from '../assets/tools-logos/tools-hubspot.svg';
import ChattitudeLogo from '../assets/chattitude_square-logo.svg';
import SalesforceLogo from '../assets/salesforcelogo.jpeg';
import StatusIoLogo from '../assets/tools-logos/tools-statusio.svg';
import CalcomLogo from '../assets/tools-logos/tools-calcom.png';
import { BASE_URL } from './Constants';

/**
 * Tool catalog entries keyed by providerKey (matches MCP integration providerKey / Tools "onSettings").
 */
export function getIntegrations(productName, reseller) {
  const chattitudeLogo = reseller?.defaultAgentFaceLogoPath
    ? (reseller.defaultAgentFaceLogoPath.startsWith('http://') || reseller.defaultAgentFaceLogoPath.startsWith('https://')
      ? reseller.defaultAgentFaceLogoPath
      : `${BASE_URL}/api/public/reseller/${reseller.id}/agent-logo`)
    : ChattitudeLogo;
  return [
    {
      name: productName,
      logo: chattitudeLogo,
      logoFallback: ChattitudeLogo,
      description: `${productName} provides in built tool to collect user information, preferences and feedback.`,
      onSettings: 'chattitude',
    },
    {
      name: 'Zoho Desk',
      logo: ZohoDeskLogo,
      description: `Connect your Zoho Desk account to sync tickets and manage support directly from ${productName}.`,
      onSettings: 'zohodesk',
    },
    {
      name: 'HubSpot',
      logo: HubSpotLogo,
      description: `Connect your HubSpot account to sync tickets and custom objects directly from ${productName}.`,
      onSettings: 'hubspot',
    },
    {
      name: 'Desk Pro',
      logo: DeskProLogo,
      description: `Connect your Desk Pro account to sync tickets and manage support directly from ${productName}.`,
      onSettings: 'deskpro',
    },
    {
      name: 'Salesforce',
      logo: SalesforceLogo,
      description: `Connect your Salesforce account to sync tickets and manage support directly from ${productName}.`,
      onSettings: 'salesforce',
      logoWidth: 100,
      logoHeight: 60,
    },
    {
      name: 'Status.io',
      logo: StatusIoLogo,
      description: `Connect Status.io public status (read-only) so agents can report service health from your configured status page API.`,
      onSettings: 'statusio',
    },
    {
      name: 'Cal.com',
      logo: CalcomLogo,
      description: `Connect Cal.com (OAuth) so agents can list event types, availability, create bookings, and open the scheduling widget in chat.`,
      onSettings: 'calcom',
    },
  ];
}

/** Map providerKey -> catalog entry for MCP card enrichment */
export function getToolCatalogByProviderKey(productName, reseller) {
  const list = getIntegrations(productName, reseller);
  const map = new Map();
  list.forEach((e) => map.set(e.onSettings, e));
  return map;
}
